















































import Vue from 'vue'
import { CardsDTO } from '@/services/dashboard/types'
import StatCard from '@/components/Stats/StatCard.vue'

type DisplayStat = { label: string; value: number | string; icon: string; color: string }
type StatSection = { key: string; title: string; icon: string; items: DisplayStat[] }

const ICON_BY_TITLE: Record<string, string> = {
  Tenders: 'mdi-file-document-multiple',
  Clients: 'mdi-briefcase-outline',
  Users: 'mdi-account-group',
}

const TONE_BY_ITEM: Record<string, string> = {
  Active: 'success',
  Ongoing: 'info',
  Pending: 'warning',
  Inactive: 'error',
}

const COLOR_TO_TONE: Record<string, string> = {
  green: 'success',
  success: 'success',
  red: 'error',
  error: 'error',
  orange: 'warning',
  warning: 'warning',
  blue: 'info',
  info: 'info',
  primary: 'primary',
}

export default Vue.extend({
  name: 'HomeStats',
  components: { StatCard },
  props: {
    statistics: { type: Array as () => CardsDTO[], default: () => [] },
    loading: { type: Boolean, default: false },
  },
  computed: {
    sections(): StatSection[] {
      return this.statistics.map(card => {
        const icon = ICON_BY_TITLE[card.title] || 'mdi-chart-box'
        return {
          key: card.title,
          title: card.title,
          icon,
          items: card.listItems.map(item => ({
            label: `${this.$tc(item.label)} ${this.$tc(card.title)}`,
            value: item.value,
            icon,
            color: TONE_BY_ITEM[item.label] || COLOR_TO_TONE[item.color] || 'primary',
          })),
        }
      })
    },
  },
})
